import { useEffect, useState } from 'react'
import { Item } from '../../../../../../../utils/types/generals'
import { RequestErrors, Roles } from '../../../../../../../utils/enums'
import { getRoles, getStore, getUserTypes, getUsers } from '../../../../../../../utils/methods/geServiceWithItemsFormat'
import { useNavigate, useParams } from 'react-router-dom'
import { departmentService } from '../../../../../../../utils/constants/callService'
import { modelsAccepted } from '../constants/equivalence'
import { User } from '../../../../../../../service/user/response'
import { Recive } from '../../../typing'

const useGetData = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [extraData, setExtraData] = useState({ area: "" })
  const [items, setItems] = useState<Record<string, Item[]>>({})
  const [itemsSetting, setItemsSetting] = useState<Record<string, Item[]>>({})
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [userTable, setUserTable] = useState<{ [x: string]: any }[]>([])
  const [loadingTable, setLoadingTable] = useState(false)
  const [dataEndpoint, setDataEndpoint] = useState<{
    name?: string
    email?: string
    phone?: string
    responsible?: {
      value: string
    } | null
    users?: {
      receive?: Record<string, Item[]> | undefined
      id: number
      status: boolean
      reassignFolio: boolean
    }[]
  }>({})

  const getData = () => {
    getUserTypeService()
    getRolesService()
    getStoresService()
    getDepartmentData()
  }

  const getUserServices = async (responsibles = []) => {
    setLoadingTable(true)
    const { items, all } = await getUsers({ skip: [Roles.ADMIN] })
    let itemsResponsible = structuredClone(items) as Item[]

    // Primero agregamos los responsables
    if (responsibles.length > 0) {
      responsibles.forEach(responsible => {
        if (!items?.some(item => item.value === responsible.value)) {
          itemsResponsible.push(responsible);
        }
      });
    }

    setItems((prev) => ({ ...prev, responsible: itemsResponsible }))
    setItemsSetting((prev) => ({ ...prev, users: items }))

    setUserTable(
      (all as User[])?.map((itemUsers) => ({
        id: itemUsers.id,
        name: `${itemUsers.firstName} ${itemUsers.lastName}`,
        curp: itemUsers.curp,
        role: itemUsers.roleId,
        roleName: itemUsers.role,
        userType: itemUsers.userTypeId,
      }))
    )

    setLoadingTable(false)
  }


  const getUserTypeService = async () => {
    const { items } = await getUserTypes()
    setItems((prev) => ({ ...prev, usersTypes: items }))
    setItemsSetting((prev) => ({ ...prev, usersTypes: items }))
  }

  const getRolesService = async () => {
    const { items } = await getRoles({ skip: [Roles.ADMIN] })
    setItems((prev) => ({ ...prev, roles: items }))
  }

  const getStoresService = async () => {
    const { items } = await getStore()
    setItemsSetting((prev) => ({ ...prev, stores: items }))
  }
  const getDepartmentData = async () => {
    if (id) {
      setLoadingDetail(true)
      const departmentDewtail = await departmentService.getDepartmentById(parseInt(id))
      if (!departmentDewtail?.errors) {
        setExtraData({ area: departmentDewtail?.area?.name ?? "" })

        // Crear array de responsables con label y value
        const responsibles = departmentDewtail?.userManager?.filter((user): user is NonNullable<typeof user> => user !== null).map(user => ({
          label: `${user.firstName} ${user.lastName} - ${user.curp}`,
          value: user.id
        })) ?? []

        await getUserServices(responsibles)
        setDataEndpoint({
          name: departmentDewtail?.name,
          email: departmentDewtail?.email,
          phone: departmentDewtail?.phone,
          responsible: responsibles,
          users: departmentDewtail?.departmentsUser?.map((itemUser) => {
            let receive: Record<string, Item[]> = {}
            const responsibleFilter = itemUser?.responsible?.filter(item =>
              [Recive.STORE, Recive.USER, Recive.USER_TYPE].includes(item.model)
            )

            if (!!responsibleFilter?.length) {
              responsibleFilter?.forEach((itemResponsable) => {
                const convert = modelsAccepted[itemResponsable.model]
                receive = {
                  ...receive,
                  [convert]: [...(receive?.[convert] || []), { value: itemResponsable.modelId, label: '' }],
                }
              })
            }

            return {
              id: itemUser.userId,
              status: !!itemUser?.historic,
              hierarchy: !!itemUser?.hierarchy,
              reassignFolio: itemUser.canReassign == 1,
              ...(!!responsibleFilter?.length && { receive }),
            }
          }),
        })

      } else {
        if (departmentDewtail?.errors[0]?.code === RequestErrors.ERR_NOT_FOUND) {
          navigate('/dashboard/organization-chart/departments/')
        }
      }
      setLoadingDetail(false)
    } else {
      // Si no hay ID, llamar a getUserServices con un array vacío
      await getUserServices({ responsible: [] })
    }
  }

  useEffect(() => {
    getData()
    //eslint-disable-next-line
  }, [])
  return { items, itemsSetting, loadingTable, userTable, loadingDetail, dataEndpoint, extraData }
}

export { useGetData }
